import { List, ListItemButton, ListItemText, styled } from '@mui/material';

export type NavItem = {
  label: string;
  path: string;
};

type SideNavProps = {
  navItems: NavItem[];
  activeTab: string;
  onTabChange: (path: string) => void;
};

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  p: 0,
  m: 0,
  '&.Mui-selected': {},
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}));

const StyledList = styled(List)({
  padding: 0
});

export const SideNav: React.FC<SideNavProps> = ({
  navItems,
  activeTab,
  onTabChange
}) => {
  return (
    <StyledList>
      {navItems.map((item) => (
        <StyledListItemButton
          key={item.path}
          selected={activeTab === item.path}
          onClick={() => onTabChange(item.path)}
        >
          <ListItemText primary={item.label} />
        </StyledListItemButton>
      ))}
    </StyledList>
  );
};
